import * as dotProp from 'dot-prop-immutable';

// Copy properties from obj2 into ob1
const dotPropCombine = (obj1, obj2) => {
  for (let field in obj2) {
    obj1 = dotProp.set(obj1, field, obj2[field]);
  }

  return obj1;
};

// export rest of api
export default dotPropCombine;
